/**
 * Отчёты и объявления, зашитые в код на случай недоступности API.
 *
 * Пути раньше были относительными (`./report.docx`) и ломались на вложенных
 * маршрутах; файлы лежат в `public/documents/` и адресуются от корня сайта.
 */

/** Отсортированы от новых к старым — в таком же порядке выводятся на странице. */
export const STATIC_REPORTS = [
  {
    id: "static-report-1-20",
    name: "Отчет №1-20 за шесть месяцев 2026 года",
    date: "2026-07-01",
    href: "/documents/otchet-1-20-6-mesyacev-2026.docx",
  },
  {
    id: "static-report-1-13",
    name: "Отчет №1-13 за первый квартал 2026 года",
    date: "2026-04-01",
    href: "/documents/otchet-1-13-1-kvartal-2026.docx",
  },
  {
    id: "static-report-1-2",
    name: "Отчет №1-2 за 12 месяцев 2025 года",
    date: "2026-01-01",
    href: "/documents/otchet-1-2-12-mesyacev-2025.docx",
  },
  {
    id: "static-report-1-41",
    name: "Отчет №1-41 за 9 месяцев 2025 года",
    date: "2025-10-01",
    href: "/documents/otchet-1-41-9-mesyacev-2025.docx",
  },
  {
    id: "static-report-1-28",
    name: "Отчет №1-28 за первое полугодие 2025 года",
    date: "2025-06-01",
    href: "/documents/report.docx",
  },
];

export const STATIC_ANNOUNCEMENTS = [
  {
    id: "static-announcement-2",
    title:
      "Объявление №2: Конкурс по покупке компьютерной техники для компьютерного класса",
    date: "20 октября 2025",
    text: "Филиал Исполнительного комитета Международного Фонда спасения Арала в Республике Таджикистан объявляет конкурс по покупке компьютерной техники и оборудования нижеследующей комплектации в количестве 6(шесть) комплектов для оснащения компьютерного класса.",
    // TODO: файл comps2.doc отсутствует в репозитории — положить в public/documents/.
    files: [
      {
        id: "static-announcement-2-doc",
        name: "Документ",
        href: "/documents/comps2.doc",
      },
    ],
  },
  {
    id: "static-announcement-1",
    title:
      "Объявление №1: Конкурс по покупке компьютерной техники для компьютерного класса",
    date: "25 августа 2025",
    text: "Филиал Исполнительного комитета Международного Фонда спасения Арала в Республике Таджикистан объявляет конкурс по покупке компьютерной техники и оборудования нижеследующей комплектации в количестве 6(шесть) комплектов для оснащения компьютерного класса.",
    files: [
      {
        id: "static-announcement-1-doc",
        name: "Документ",
        href: "/documents/comps.doc",
      },
    ],
  },
];
